var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loginWrapper" }, [
    _c("div", { staticClass: "innerWrapper" }, [
      _c("div", { staticClass: "logo" }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "72",
              height: "32",
              viewBox: "0 0 72 32"
            }
          },
          [
            _c("g", { attrs: { fill: "#323b46", "fill-rule": "evenodd" } }, [
              _c("path", {
                attrs: {
                  d:
                    "M69.429 21.076l-.145.287c-.331.606-.476.85-.953 1.497-.617.085-.874.114-1.36.114-1.54 0-4.08-.562-6.101-1.343l-3.486-1.337c-2.355-.889-4.508-1.402-6.074-1.402-1.315 0-3.611.49-5.215 1.095l-4.34 1.644c-2.044.806-4.56 1.343-6.074 1.343-1.527 0-4.03-.537-6.082-1.343l-4.346-1.644c-1.59-.606-3.896-1.095-5.214-1.095-1.555 0-3.72.513-6.084 1.402l-3.477 1.337c-2.017.781-4.556 1.343-6.11 1.343-.492 0-.733-.029-1.336-.114-.452-.582-.622-.869-.964-1.497l-.14-.287c1.171.222 1.833.315 2.481.315 1.54 0 3.755-.516 6.07-1.43l3.476-1.337c1.845-.714 4.593-1.29 6.084-1.29 1.494 0 4.236.576 6.073 1.29L29.6 19.96c2.313.915 4.528 1.43 6.068 1.43 1.558 0 3.773-.515 6.088-1.43l3.485-1.336c1.825-.714 4.574-1.29 6.061-1.29 1.504 0 4.25.576 6.083 1.29l3.486 1.336c2.313.915 4.529 1.43 6.074 1.43.652 0 1.304-.092 2.485-.314zm-5.533 4.438c-.528.555-.67.688-1.27 1.154l-2.779-.98-3.218-1.087c-2.437-.844-4.086-1.196-5.495-1.196-1.272 0-3.6.486-5.149 1.085l-4.284 1.665c-2 .779-4.503 1.312-6.02 1.332-1.52 0-4.019-.553-6.02-1.332l-4.293-1.665c-1.538-.599-3.864-1.085-5.148-1.085-1.404 0-3.053.352-5.502 1.196l-3.21 1.087-2.774.98c-.597-.466-.735-.599-1.273-1.154l4.994-1.777c2.2-.779 3.134-1.071 4.317-1.38 1.252-.311 2.533-.51 3.448-.51 1.459 0 4.223.597 6.01 1.29l3.431 1.353c2.33.912 4.451 1.399 6.02 1.399 1.555 0 3.696-.509 6.02-1.4l3.44-1.353c1.77-.692 4.539-1.29 5.993-1.29.916 0 2.187.2 3.45.512 1.21.308 2.072.58 4.32 1.379l4.992 1.777zm-5.533 2.602l-1.731 1.043-.393-.132c-2.007-.713-3.746-1.09-5.075-1.09-1.356 0-2.972.333-5.166 1.09l-.847.312-.874.332-.856.332-.866.332-.855.333-.866.287C39.02 31.6 36.998 32 35.684 32c-1.54 0-3.445-.421-6.026-1.332l-.861-.333-.862-.332-.86-.332-.87-.332-.851-.312-.862-.287c-1.431-.491-3.184-.803-4.29-.803-1.337 0-3.068.377-5.09 1.09l-.387.132-1.73-1.043c.436-.179.57-.222 1.168-.447l.865-.286c1.721-.598 3.875-1.024 5.16-1.024 1.522 0 3.518.446 6.016 1.31l.87.333.86.333.863.337.86.335.86.305c1.847.667 3.832 1.09 5.152 1.09 1.551 0 3.417-.423 6.03-1.395l.856-.335.866-.337.856-.333c.149-.065.429-.174.874-.333l.847-.286c1.723-.598 3.88-1.024 5.157-1.024 1.525 0 3.532.446 6.025 1.31l.87.333.313.114zM10.074 6.979v3.97c-.89.365-1.77.569-2.644.569-2.277 0-3.862-1.813-3.862-4.357 0-2.745 1.906-4.679 4.635-4.679 1.53 0 3.043.447 4.874 1.423V1.262C10.738.286 9.588 0 7.847 0 3.06 0 0 2.769 0 7.124 0 11.254 2.973 14 7.43 14c1.985 0 4.347-.648 6.07-1.685V6.98h-3.426M15.429 0v14h3.543V2.652h1.53c2.006 0 2.904.646 2.904 2.112 0 1.504-1.003 2.368-2.77 2.368l-.77-.025h-.401L24.39 14h4.539l-4.53-5.622c1.69-.793 2.576-2.174 2.576-3.983 0-2.974-1.86-4.395-5.753-4.395h-5.793M46.286 0v14h3.245V8.01h5.731V14H58.5V0h-3.238v5.17h-5.73V0zM61.714 0v14H72v-2.737h-6.717V7.928h4.95V5.3h-4.95V2.737h5.936V0zM32.38 7.002c0-2.68 1.745-4.56 4.263-4.56 2.509 0 4.261 1.88 4.261 4.56 0 2.678-1.752 4.557-4.26 4.557-2.51 0-4.264-1.879-4.264-4.557m-3.451 0c0 4.04 3.255 6.998 7.714 6.998 4.448 0 7.714-2.958 7.714-6.998C44.348 2.962 41.1 0 36.643 0c-4.459 0-7.714 2.962-7.714 7.002"
                }
              })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("h1", [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.$stringFile[[_vm.$store.getters.getUserHomeLanguage]]
                .dashboard.welcome
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "loaderContainer" },
        [
          _vm.showLoader
            ? _c("clip-loader", {
                attrs: {
                  loading: _vm.showLoader,
                  size: _vm.sizeLoader,
                  color: _vm.colorLoader
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showLoginBtn
            ? _c(
                "button",
                {
                  staticClass: "loginBtn",
                  on: {
                    click: function($event) {
                      _vm.loginOIDC()
                    }
                  }
                },
                [_vm._v("Bring me to the login page")]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cd44393", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd44393","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login-component.vue
// module id = null
// module chunks = 